import { ActionEnum } from '../action.enum';
import { CheckinTemplateDetailMenuEnum } from '../../enums/checkin-template/checkin-template-detail-menu.enum';
import { CheckinTemplateInfoDto } from '../../models/checkin-template/checkin-template-info-dto.model';

export namespace CheckinTemplateDetailAction {

  export class LoadCheckinTemplate {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_LOAD;
    constructor(public id: string) {}
  }

  export class SelectMenu {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_SELECT_MENU;
    constructor(public menu: CheckinTemplateDetailMenuEnum) {}
  }

  export class DeleteCheckinTemplate {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_DELETE;
    constructor(public id: string) {}
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_RESET_STATE;
  }

  export class LoadClasses {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_LOAD_CLASSES;
    constructor(public readonly force: boolean = false) {}
  }

  export class ChangeClassSelection {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_CHANGE_CLASS_SELECTION;
    constructor(public ids: Set<string>) {}
  }

  export class SaveClassSelection {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_SAVE_CLASS_SELECTION;
  }

  export class ResetClassSelection {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_RESET_CLASS_SELECTION;
  }

  export class UpdateInfo {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_UPDATE_INFO;
    constructor(public dto: CheckinTemplateInfoDto) {}
  }

  export class LoadReferences {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_LOAD_REFERENCES;
    constructor(public readonly force: boolean = false) {}
  }

  export class AddReference {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_ADD_REFERENCE;
    constructor(
      public name: string,
      public classIds: string[]
    ) {}
  }

  export class UpdateReferenceClasses {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_UPDATE_REFERENCE_CLASSES;
    constructor(
      public index: number,
      public classIds: string[]
    ) {}
  }

  export class UpdateReference {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_UPDATE_REFERENCE;
    constructor(
      public index: number,
      public name: string,
      public required: boolean,
      public minQuantity: number | null
    ) {}
  }

  export class RemoveReference {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_REMOVE_REFERENCE;
    constructor(public index: number) {}
  }

  export class ReorderReferences {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_REORDER_REFERENCES;
    constructor(
      public previousIndex: number,
      public currentIndex: number
    ) {}
  }

  export class SaveReferences {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_SAVE_REFERENCES;
  }

  export class ResetReferences {
    static readonly type: ActionEnum = ActionEnum.CHECKIN_TEMPLATE_DETAIL_RESET_REFERENCES;
  }
}
